
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as index_45zP1k_456PegClMGLevyC8_45fOeB4e6JpZR3wEnxj9ZjmkMeta } from "/workspace/Optilink/management-tool-frontend/pages/index.vue?macro=true";
import { default as LogintsrbAmLbckmJk8Edk0iiho4R02sFAZONPThg4ndAU1wMeta } from "/workspace/Optilink/management-tool-frontend/pages/Login.vue?macro=true";
import { default as buffersA6jkR3ilUpkvPqchBVC6FKZA4aX5TCyYBxsSdOwxO5MMeta } from "/workspace/Optilink/management-tool-frontend/pages/buffers.vue?macro=true";
import { default as devicesQn2dBE6w_2b8qk2FR6onEILt9VqUYXN5YkYjauPqmAgMeta } from "/workspace/Optilink/management-tool-frontend/pages/devices.vue?macro=true";
import { default as domainsn8KxhdkHxkATQU0yVunvrrSnP9cGVWiLHrakGiQZHvIMeta } from "/workspace/Optilink/management-tool-frontend/pages/domains.vue?macro=true";
import { default as bug_45reportsw3WtFfikjbMl5g547lZP2pJh4AmqI_45AeTGwWBoKJJdsMeta } from "/workspace/Optilink/management-tool-frontend/pages/support/bug-reports.vue?macro=true";
import { default as feature_45requestswf8QEFTDdmH0Rks6xWxkY0YglwhHwH47psNLQ3f_3TkMeta } from "/workspace/Optilink/management-tool-frontend/pages/support/feature-requests.vue?macro=true";
import { default as supportgCIYiRR1I_45ZNh4F1Kd1K7SUdU0eYNlzDM20LU_d0A0kMeta } from "/workspace/Optilink/management-tool-frontend/pages/support.vue?macro=true";
import { default as accountsg6PL7v4oE21dquxaFk_45nnlo_457VJSTjdZgtc5QwY4ix4Meta } from "/workspace/Optilink/management-tool-frontend/pages/accounts.vue?macro=true";
import { default as rolesHgNTfptf7xuKlrrDFVSVm926_45yG6TkAjYcushAC5ckQMeta } from "/workspace/Optilink/management-tool-frontend/pages/security/roles.vue?macro=true";
import { default as policiesUCxiBSOr3vOq4aGPd3hw_45k_45hP1v7SSygJmhrlQjL_mcMeta } from "/workspace/Optilink/management-tool-frontend/pages/security/policies.vue?macro=true";
import { default as securitytRvAz036hyGotyAxW69jf0vxSPEQwD0wDOyS7cJbeJgMeta } from "/workspace/Optilink/management-tool-frontend/pages/security.vue?macro=true";
import { default as dashboardrXFc90KQDY7U_sstgkzZK29pKUaV3S1AJj6AhvVaTPoMeta } from "/workspace/Optilink/management-tool-frontend/pages/dashboard.vue?macro=true";
import { default as ftp_45usersklpXQ44a9i2p1ccwBG8GosZ3Iy5BKeFtlscftDZzKd4Meta } from "/workspace/Optilink/management-tool-frontend/pages/ftp-users.vue?macro=true";
import { default as mail_45users5W_45PUMhjwZ3irm4HMMeoP0uSr2InPtd3livDLhKgpdcMeta } from "/workspace/Optilink/management-tool-frontend/pages/mail-users.vue?macro=true";
import { default as access_45groupsxquhD8BNVsUnmb6LMWlOJK_456_45HxW_45fA4J6SkFQIRT5gMeta } from "/workspace/Optilink/management-tool-frontend/pages/access-groups.vue?macro=true";
import { default as adf_45managementXjFws39Hwp6qlOv1dKadv2WauV7dIMOaOfiJwPEODR0Meta } from "/workspace/Optilink/management-tool-frontend/pages/adf-management.vue?macro=true";
import { default as export_45monitorkPRhBW5V6kSfU0dI2F_45HrWKOCwaLd__45g5kvKwiyCHGMMeta } from "/workspace/Optilink/management-tool-frontend/pages/export-monitor.vue?macro=true";
import { default as forgot_45passwordOLKw5gFB_45nJOhugiURT4hp1y9L1gRF7UPJaS32h8R8AMeta } from "/workspace/Optilink/management-tool-frontend/pages/forgot-password.vue?macro=true";
import { default as device_45templates_h88bCQSjlG9a6_45kzk26eoquVpSHcf2_w8g1p3O_450OcMeta } from "/workspace/Optilink/management-tool-frontend/pages/device-templates.vue?macro=true";
import { default as export_45templatesefvXzGUH38hgirX51Nbuj4vbjPFwdXd_5u8VQdg_njAMeta } from "/workspace/Optilink/management-tool-frontend/pages/export-templates.vue?macro=true";
import { default as firmware_45versionsOiZSYdntDN8i11Sse4tYWFFW6uWTiHAYMX5PkppvKI8Meta } from "/workspace/Optilink/management-tool-frontend/pages/firmware-versions.vue?macro=true";
import { default as subscription_45plansrljxcojxpQEK3XVe_c32JPB5aBITw70dDem3lknLGfwMeta } from "/workspace/Optilink/management-tool-frontend/pages/subscription-plans.vue?macro=true";
import { default as key_45pair_45managementzs9Dd1nmbTtLvgo_45gYUssf1_w0w0D60YvF8JBW3MR44Meta } from "/workspace/Optilink/management-tool-frontend/pages/key-pair-management.vue?macro=true";
import { default as device_45control_45panellUrnksTwHZbQovAuLMXIv7MWjF7V3UznN9taMohcng0Meta } from "/workspace/Optilink/management-tool-frontend/pages/device-control-panel.vue?macro=true";
import { default as export_45templateswcSRI2KjP49tklHYMBXuxEblM5Z7rm9d7S8tRGf8DLoMeta } from "/workspace/Optilink/management-tool-frontend/pages/help/export-templates.vue?macro=true";
import { default as dealers_45and_45subdealersmfdMODwu3V6dsKVo3wObE6DydpXOVP2dzCalkg3h6XgMeta } from "/workspace/Optilink/management-tool-frontend/pages/dealers-and-subdealers.vue?macro=true";
import { default as virtual_45devices_45managementb3nfkblFszTw2iMID0ZZfCPQF42hnO6LY2WiAttOL1oMeta } from "/workspace/Optilink/management-tool-frontend/pages/virtual-devices-management.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: { ...(index_45zP1k_456PegClMGLevyC8_45fOeB4e6JpZR3wEnxj9ZjmkMeta || {}), ...{"middleware":["is-authenticated"]} },
    component: () => import("/workspace/Optilink/management-tool-frontend/pages/index.vue")
  },
  {
    name: "Login",
    path: "/Login",
    meta: LogintsrbAmLbckmJk8Edk0iiho4R02sFAZONPThg4ndAU1wMeta || {},
    component: () => import("/workspace/Optilink/management-tool-frontend/pages/Login.vue")
  },
  {
    name: "buffers",
    path: "/buffers",
    meta: { ...(buffersA6jkR3ilUpkvPqchBVC6FKZA4aX5TCyYBxsSdOwxO5MMeta || {}), ...{"middleware":["is-authenticated"]} },
    component: () => import("/workspace/Optilink/management-tool-frontend/pages/buffers.vue")
  },
  {
    name: "devices",
    path: "/devices",
    meta: { ...(devicesQn2dBE6w_2b8qk2FR6onEILt9VqUYXN5YkYjauPqmAgMeta || {}), ...{"middleware":["is-authenticated"]} },
    component: () => import("/workspace/Optilink/management-tool-frontend/pages/devices.vue")
  },
  {
    name: "domains",
    path: "/domains",
    meta: domainsn8KxhdkHxkATQU0yVunvrrSnP9cGVWiLHrakGiQZHvIMeta || {},
    component: () => import("/workspace/Optilink/management-tool-frontend/pages/domains.vue")
  },
  {
    name: "support",
    path: "/support",
    meta: { ...(supportgCIYiRR1I_45ZNh4F1Kd1K7SUdU0eYNlzDM20LU_d0A0kMeta || {}), ...{"middleware":["is-authenticated"]} },
    component: () => import("/workspace/Optilink/management-tool-frontend/pages/support.vue"),
    children: [
  {
    name: "support-bug-reports",
    path: "bug-reports",
    meta: { ...(bug_45reportsw3WtFfikjbMl5g547lZP2pJh4AmqI_45AeTGwWBoKJJdsMeta || {}), ...{"middleware":["is-authenticated"]} },
    component: () => import("/workspace/Optilink/management-tool-frontend/pages/support/bug-reports.vue")
  },
  {
    name: "support-feature-requests",
    path: "feature-requests",
    meta: { ...(feature_45requestswf8QEFTDdmH0Rks6xWxkY0YglwhHwH47psNLQ3f_3TkMeta || {}), ...{"middleware":["is-authenticated"]} },
    component: () => import("/workspace/Optilink/management-tool-frontend/pages/support/feature-requests.vue")
  }
]
  },
  {
    name: "accounts",
    path: "/accounts",
    meta: { ...(accountsg6PL7v4oE21dquxaFk_45nnlo_457VJSTjdZgtc5QwY4ix4Meta || {}), ...{"middleware":["is-authenticated"]} },
    component: () => import("/workspace/Optilink/management-tool-frontend/pages/accounts.vue")
  },
  {
    name: "security",
    path: "/security",
    meta: { ...(securitytRvAz036hyGotyAxW69jf0vxSPEQwD0wDOyS7cJbeJgMeta || {}), ...{"middleware":["is-authenticated"]} },
    component: () => import("/workspace/Optilink/management-tool-frontend/pages/security.vue"),
    children: [
  {
    name: "security-roles",
    path: "roles",
    meta: { ...(rolesHgNTfptf7xuKlrrDFVSVm926_45yG6TkAjYcushAC5ckQMeta || {}), ...{"middleware":["is-authenticated"]} },
    component: () => import("/workspace/Optilink/management-tool-frontend/pages/security/roles.vue")
  },
  {
    name: "security-policies",
    path: "policies",
    meta: { ...(policiesUCxiBSOr3vOq4aGPd3hw_45k_45hP1v7SSygJmhrlQjL_mcMeta || {}), ...{"middleware":["is-authenticated"]} },
    component: () => import("/workspace/Optilink/management-tool-frontend/pages/security/policies.vue")
  }
]
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: { ...(dashboardrXFc90KQDY7U_sstgkzZK29pKUaV3S1AJj6AhvVaTPoMeta || {}), ...{"middleware":["is-authenticated"]} },
    component: () => import("/workspace/Optilink/management-tool-frontend/pages/dashboard.vue")
  },
  {
    name: "ftp-users",
    path: "/ftp-users",
    meta: { ...(ftp_45usersklpXQ44a9i2p1ccwBG8GosZ3Iy5BKeFtlscftDZzKd4Meta || {}), ...{"middleware":["is-authenticated"]} },
    component: () => import("/workspace/Optilink/management-tool-frontend/pages/ftp-users.vue")
  },
  {
    name: "mail-users",
    path: "/mail-users",
    meta: { ...(mail_45users5W_45PUMhjwZ3irm4HMMeoP0uSr2InPtd3livDLhKgpdcMeta || {}), ...{"middleware":["is-authenticated"]} },
    component: () => import("/workspace/Optilink/management-tool-frontend/pages/mail-users.vue")
  },
  {
    name: "access-groups",
    path: "/access-groups",
    meta: { ...(access_45groupsxquhD8BNVsUnmb6LMWlOJK_456_45HxW_45fA4J6SkFQIRT5gMeta || {}), ...{"middleware":["is-authenticated"]} },
    component: () => import("/workspace/Optilink/management-tool-frontend/pages/access-groups.vue")
  },
  {
    name: "adf-management",
    path: "/adf-management",
    meta: { ...(adf_45managementXjFws39Hwp6qlOv1dKadv2WauV7dIMOaOfiJwPEODR0Meta || {}), ...{"middleware":["is-authenticated"]} },
    component: () => import("/workspace/Optilink/management-tool-frontend/pages/adf-management.vue")
  },
  {
    name: "export-monitor",
    path: "/export-monitor",
    meta: { ...(export_45monitorkPRhBW5V6kSfU0dI2F_45HrWKOCwaLd__45g5kvKwiyCHGMMeta || {}), ...{"middleware":["is-authenticated"]} },
    component: () => import("/workspace/Optilink/management-tool-frontend/pages/export-monitor.vue")
  },
  {
    name: "forgot-password",
    path: "/forgot-password",
    component: () => import("/workspace/Optilink/management-tool-frontend/pages/forgot-password.vue")
  },
  {
    name: "device-templates",
    path: "/device-templates",
    meta: device_45templates_h88bCQSjlG9a6_45kzk26eoquVpSHcf2_w8g1p3O_450OcMeta || {},
    component: () => import("/workspace/Optilink/management-tool-frontend/pages/device-templates.vue")
  },
  {
    name: "export-templates",
    path: "/export-templates",
    meta: { ...(export_45templatesefvXzGUH38hgirX51Nbuj4vbjPFwdXd_5u8VQdg_njAMeta || {}), ...{"middleware":["is-authenticated"]} },
    component: () => import("/workspace/Optilink/management-tool-frontend/pages/export-templates.vue")
  },
  {
    name: "firmware-versions",
    path: "/firmware-versions",
    meta: { ...(firmware_45versionsOiZSYdntDN8i11Sse4tYWFFW6uWTiHAYMX5PkppvKI8Meta || {}), ...{"middleware":["is-authenticated"]} },
    component: () => import("/workspace/Optilink/management-tool-frontend/pages/firmware-versions.vue")
  },
  {
    name: "subscription-plans",
    path: "/subscription-plans",
    meta: { ...(subscription_45plansrljxcojxpQEK3XVe_c32JPB5aBITw70dDem3lknLGfwMeta || {}), ...{"middleware":["is-authenticated"]} },
    component: () => import("/workspace/Optilink/management-tool-frontend/pages/subscription-plans.vue")
  },
  {
    name: "key-pair-management",
    path: "/key-pair-management",
    meta: { ...(key_45pair_45managementzs9Dd1nmbTtLvgo_45gYUssf1_w0w0D60YvF8JBW3MR44Meta || {}), ...{"middleware":["is-authenticated"]} },
    component: () => import("/workspace/Optilink/management-tool-frontend/pages/key-pair-management.vue")
  },
  {
    name: "device-control-panel",
    path: "/device-control-panel",
    meta: device_45control_45panellUrnksTwHZbQovAuLMXIv7MWjF7V3UznN9taMohcng0Meta || {},
    component: () => import("/workspace/Optilink/management-tool-frontend/pages/device-control-panel.vue")
  },
  {
    name: "help-export-templates",
    path: "/help/export-templates",
    component: () => import("/workspace/Optilink/management-tool-frontend/pages/help/export-templates.vue")
  },
  {
    name: "dealers-and-subdealers",
    path: "/dealers-and-subdealers",
    meta: { ...(dealers_45and_45subdealersmfdMODwu3V6dsKVo3wObE6DydpXOVP2dzCalkg3h6XgMeta || {}), ...{"middleware":["is-authenticated"]} },
    component: () => import("/workspace/Optilink/management-tool-frontend/pages/dealers-and-subdealers.vue")
  },
  {
    name: "virtual-devices-management",
    path: "/virtual-devices-management",
    meta: { ...(virtual_45devices_45managementb3nfkblFszTw2iMID0ZZfCPQF42hnO6LY2WiAttOL1oMeta || {}), ...{"middleware":["is-authenticated"]} },
    component: () => import("/workspace/Optilink/management-tool-frontend/pages/virtual-devices-management.vue")
  }
]